var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#warning_svg__filter0_d_13388_9977)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 26,
    r: 20,
    fill: "#FA9F47"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 26,
    r: 17.833,
    stroke: "#fff",
    strokeWidth: 4.333
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 30.238a1.83 1.83 0 01-1.818-1.817v-9.693a1.83 1.83 0 011.817-1.818 1.83 1.83 0 011.818 1.818v9.693a1.83 1.83 0 01-1.818 1.817zM27 36.634a1.74 1.74 0 01-.704-.145 1.534 1.534 0 01-.581-.388 1.534 1.534 0 01-.388-.582 1.739 1.739 0 01-.145-.702c0-.243.048-.46.145-.703a1.88 1.88 0 01.388-.582c.678-.678 1.89-.678 2.568 0 .17.17.291.364.388.582.097.242.146.46.146.703 0 .242-.049.484-.146.702a1.535 1.535 0 01-.388.582c-.339.34-.8.533-1.284.533z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "warning_svg__filter0_d_13388_9977",
    x: 0,
    y: 0,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13388_9977"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_13388_9977",
    result: "shape"
  })))));
}
export default SvgWarning;